module.exports = __webpack_public_path__ + "static/media/workspace.909602da.png";